import styled from 'styled-components/macro'

export const IdentityProviderInputContainer = styled.div`
  width: 100%;
  text-align: center;

  &.error {
    input {
      border: 1px solid #ff0000;
    }
  }
`

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
`
